import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
//import propertytypesApi from "../../api/propertytype";
import IntlMessages from "../../components/IntlMessage";
import {
  Button,
  Card,
  Table,
  Modal,
  Row,
  Col,
  Space,
  Typography,
  Switch,
} from "antd";
import PageTitle from "../../components/PageTitle";
import _, { debounce } from "lodash";
import { useIntl } from "react-intl";
import ActionBar from "../../components/ActionBar";
import FilterBar from "../../components/FilterBar";
import CustomersForm from "./CustomersForm";
import customersApi from "../../api/customers";
import dayjs from "dayjs";
import { mapCountry } from "../../helpers/helpers";
import {
  CheckCircleOutlined,
  EditOutlined,
  UserOutlined,
} from "@ant-design/icons";
import moment from "moment";
import IntlMessage from "../../components/IntlMessage";

const { Text } = Typography;

Customers.propTypes = {
  items: PropTypes.array,
};
Customers.defaultProps = {
  items: [],
};

function Customers(props) {
  // const isMount = useRef(false)

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [condition, setCondition] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: "",
    order_by: "id",
    order_dir: "DESC",
  });
  const [modal, setModal] = useState(false);

  const countryData = useMemo(mapCountry, []);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await customersApi.getAll(filter);

      // console.log(' list customer', items.data);
      setItems(items.data);
      setLoading(false);
      // setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : "id",
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === "search") {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        console.log("key: ", key);
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };
  const intl = useIntl();
  // const onRemove = (data) => {
  //   Modal.confirm({
  //     title: intl.formatMessage({ id: 'global.delete_confirm' }),
  //     okText: intl.formatMessage({ id: 'global.yes' }),
  //     onOk: async () => {
  //       await customersApi.delete(data.id).catch((error) => {
  //         console.error(error);
  //         Modal.error({
  //           title: error.data.message,
  //           okText: intl.formatMessage({ id: 'global.close' }),
  //         });
  //         setLoading(false);
  //       });
  //       setDeleting(true);
  //     },
  //     onCancel() {},
  //   });
  // };
  const onChangeStatus = async (ischecked, record) => {
    console.log(ischecked);
    await customersApi.updateStatus(record.id, { status: ischecked });

    setItems((items) =>
      items.map((data) => {
        if (data.id === record.id)
          return {
            ...data,
            status: ischecked,
          };
        return data;
      })
    );
  };

  const getOrder = (order) => {
    if (order === "ascend") return "ASC";
    if (order === "descend") return "DESC";
    return "DESC";
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await customersApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: "global.close" }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const columns = [
    // {
    //   title: <IntlMessages id="global.id" />,
    //   key: 'id',
    //   sorter: true,
    //   dataIndex: 'id',
    //   width: 20,
    //   render: (text, record) => {
    //     return record.id;
    //   },
    // },
    {
      title: <IntlMessages id="global.firstname" />,
      key: "firstname",
      sorter: true,

      dataIndex: "firstname",
      render: (text, record) => {
        //return `${record.firstname}`;
        return (
          <Button
            type="link"
            size="small"
            onClick={() => onOpenModal(record)}
            shape="round"
          >
            {record.firstname}
          </Button>
        );
      },
    },

    {
      title: <IntlMessages id="global.lastname" />,
      key: "lastname",
      sorter: true,

      dataIndex: "lastname",
      render: (text, record) => {
        return `${record.lastname}`;
      },
    },

    // {
    //   title: <IntlMessages id="global.fullname" />,
    //   key: "fullname",
    //   sorter: true,

    //   dataIndex: "fullname",
    //   render: (text, record) => {
    //     //return `${record.fullname}`;
    //     return (
    //       <Button
    //         type="primary"
    //         size="small"
    //         onClick={() => onOpenModal(record)}
    //         shape="round"
    //         icon={<EditOutlined />}
    //       >
    //         {record.fullname}
    //       </Button>
    //     );
    //   },
    // },

    {
      title: <IntlMessages id="global.phone" />,
      key: "mobile",
      sorter: true,

      dataIndex: "mobile",
      render: (text, record) => {
        return record.phone_code
          ? `(${record.phone_code})${record.mobile}`
          : record.mobile;
      },
    },
    {
      title: <IntlMessages id="global.passport" />,
      key: "passport",
      sorter: true,

      dataIndex: "passport",
      render: (text, record) => {
        return record.passport;
      },
    },
    {
      title: <IntlMessages id="global.status" />,
      dataIndex: "status",
      width: 100,
      key: "status",
      render: (e, record) =>
        record ? (
          <Switch
            // checkedChildren={<IntlMessages id="global.published" />}
            // unCheckedChildren={<IntlMessages id="global.unpublished" />}
            defaultChecked={e}
            onChange={(ischecked) => onChangeStatus(ischecked, record)}
          />
        ) : null,
    },
    {
      title: <IntlMessages id="global.userId" />,
      key: "user",
      sorter: true,

      dataIndex: "user",
      render: (text, record) => {
        return record?.user?.id ? record?.user?.id : "N/A";
      },
    },
    {
      title: <IntlMessages id="global.created_at" />,
      key: "created_at",
      sorter: true,
      dataIndex: "created_at",
      render: (text, record) => {
        return moment(record.created_at).format("MM/DD hh:mm");
      },
    },
    {
      title: <IntlMessages id="global.id" />,
      key: "id",
      sorter: true,

      dataIndex: "id",
      render: (text, record) => {
        return record?.id ? record?.id : "N/A";
      },
    },
  ];

  return (
    <Card bordered={false} style={{ minHeight: "100%" }}>
      <Row justify="space-between">
        <Col>
          {" "}
          <PageTitle title={<IntlMessages id="global.customers" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={true}
            isDisabled={!(selectedRowKeys.length > 0)}
          ></ActionBar>
        </Col>
      </Row>

      <FilterBar
        onFilter={onFilter}
        data={[
          {
            name: "status",
            data: [
              { title: "Active", value: "1" },
              { title: "Inactive", value: "0" },
            ],
            placeholder: <IntlMessage id="global.status" />,
          },
        ]}
      />

      <br />

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: "max-content",
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        rowSelection={rowSelection}
      />
      {modal ? (
        <CustomersForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
    </Card>
  );
}

export default Customers;
